import React, { useState } from 'react';
import { CgClose } from 'react-icons/cg';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
import SummaryApi from '../common';

const UserEditOrderStatus = ({ onClose, orderData, fetchData }) => {
  const { id, type } = useParams(); 
  const [status, setStatus] = useState(orderData?.status || ''); // Initialize status

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Set status to 'done' when submitting
    const updatedStatus = 'done';

    try {
        const response = await fetch(`${SummaryApi.userEditOrderStatus.url}/${id}/${type}`, {
            method: SummaryApi.userEditOrderStatus.method,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ newStatus: updatedStatus }), // Use updatedStatus
        });

        const responseData = await response.json();

        if (response.ok && responseData.success) {
            toast.success('تم تاكيداستلام الطلب بنجاح');
            onClose();
            window.location.reload(); // Refresh the page after update
        } else {
            toast.error(responseData.message || 'حدث خطأ');
        }
    } catch (error) {
        toast.error('حدث خطأ');
    }
  };

  return (
    <div className='fixed w-full h-full bg-slate-200 bg-opacity-35 top-0 left-0 right-0 bottom-0 flex justify-center items-center'>
      <div className='bg-white p-4 rounded w-full max-w-md'>
        <div className='flex justify-between items-center pb-3'>
          <h2 className='font-bold text-lg'>Edit Order Status</h2>
          <div className='text-2xl hover:text-red-600 cursor-pointer' onClick={onClose}>
            <CgClose />
          </div>
        </div>
        <form onSubmit={handleSubmit}>
          <label htmlFor='status' className='block mb-2 text-right'>حالة الطلب</label>
          <select
            id='status'
            value={status}
            onChange={(e) => setStatus(e.target.value)} // Update state based on dropdown selection
            className='p-2 bg-slate-100 border rounded w-full text-right'
          >
            <option value='done'>تم ايصال الطلب بنجاح</option>
            {/* Add more status options as needed */}
          </select>
          
          <label htmlFor='status' className='block mb-2 text-right text-red-500'>.يرجى العلم انه في حالة تاكيد الاستلام لا يمكن الرجوع عن هذه الخطوة لذا تاكد جيدا من استلام الطلب</label>
          <button 
            type='submit' 
            className='mt-4 px-4 py-2 bg-blue-500 text-white rounded-lg'
          >
            تاكيد الاستلام
          </button>
        </form>
      </div>
    </div>
  );
};

export default UserEditOrderStatus;
